module.exports = __webpack_public_path__ + "img/high-volume.33282c53.svg";